export default __webpack_public_path__ + "static/media/youtube-icon.60f327df.svg";